import axios from 'axios';
axios.defaults.withCredentials = false;
axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";
var axiosInstance = axios.create();
export default axiosInstance;



//////////////////
// WEBPACK FOOTER
// ./src/classes/http/AxiosInstance.ts
// module id = 230
// module chunks = 0